var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "201px",
    height: "201px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#fe718d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.7976071784646063s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.176470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#f47e60"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.7477567298105683s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(42.35294117647059 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#f8b26a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.6979062811565304s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(63.529411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#abbd81"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.6480558325024925s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(84.70588235294117 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#849b87"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.5982053838484547s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(105.88235294117646 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#6492ac"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.5483549351944168s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(127.05882352941177 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#637cb5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.4985044865403789s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(148.23529411764707 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#6a63b6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.448654037886341s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.41176470588235 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#fe718d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.39880358923230314s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.58823529411765 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#f47e60"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.3489531405782652s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(211.76470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#f8b26a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.29910269192422734s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(232.94117647058823 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#abbd81"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.24925224327018944s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(254.11764705882354 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#849b87"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.19940179461615157s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(275.29411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#6492ac"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.14955134596211367s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(296.47058823529414 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#637cb5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.09970089730807578s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(317.6470588235294 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#6a63b6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "-0.04985044865403789s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.8235294117647 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20.5,
    rx: 1.98,
    ry: 1.98,
    width: 4,
    height: 11,
    fill: "#fe718d"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.8474576271186441s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5377711b14fe21cd13d53a3f477359ca.svg";
export { ForwardRef as ReactComponent };